// extracted by mini-css-extract-plugin
export default {"empty":"CollectionListing_empty__3cVk-"};